import React, { useState } from 'react'
import {
  FormDashboardLabel as Label,
  GalleryDropzonePreview,
  GalleryForm,
} from '../../../components'
import { ProgressBar } from '.'
import { Link } from 'react-router-dom'
import { NotificationFormPopup } from './notification-form-popup'
import { FormLocation, FormLocationOnline, FormProfile } from '../../../features/event-form/components'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce'
import { addToHolder, updateForm } from '../../../features/event-form/slice'
import Select from 'react-select'
import SectionTestimonial from './section-testimonial'
import SectionComment from './section-comment'
import DevLogger from '../../../components/_dev-logger'
import { SidebarStatus } from './sidebar-status'
import dayjs from 'dayjs'
import 'dayjs/locale/id'
import { useViewport } from '../../../utils'
import { useInternationalization } from '../../../features/i18n'

const Form = ({isEdit}) => {
  //eslint-disable-next-line
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const [notificationFormPopedUp, setNotificationFormPopedUp] = React.useState(false)
  const form = useSelector(state => state.eventForm.data)
  const [locationType, setLocationType] = useState({
    label: isEdit ? 'Both' : 'Offline',
    value: isEdit ? 'both' : 'offline'
  })
  const { translate, language } = useInternationalization()

  const {
    id,
    registration_end_date,
    guest_seat,
    guest_total,
    registrationType,
  } = form

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const handleGalleryChange = (res) => {
    const { images, blobs } = res
    const input = {
      target: {
        name: 'gallery',
        value: blobs.map((blob, index) => {
          return {
            blob,
            name: images[index].name,
            type: images[index].type,
          }
        })
      }
    }

    handleInput(input)
  }

  const handleDeleteGalleryItem = (index) => {
    console.log('delete this gallery item:', form.gallery_saved[index])
    const id = form.gallery_saved[index].pkId

    // Effect 1: add to holder
    dispatch(addToHolder({entity: 'gallery', type: 'delete', id}))

    // Experiment: create holder inside form
    setTimeout(() => {
      const currentHolder = form.gallery_holder_delete ?
        [...form.gallery_holder_delete] : []
      currentHolder.push(id)
      console.log(currentHolder)
      handleInput({
        target: {
          name: 'gallery_holder_delete',
          value: currentHolder
        }
      })
    }, 300)

    // Effect 2: change UI
    const input = {
      target: {
        name: 'gallery_saved',
        value: form.gallery_saved.filter((g, i) => i !== index)
      }
    }
    handleInput(input)
  }

  return (
    <div>
      {
        !isDesktop &&
        <div className="mobile-fullwidth">
          <div className="p-5 mb-8" style={{background: '#f5f5f5'}}>
            {
              registrationType === 'internal' &&
              <ProgressBar progress={guest_total} total={guest_seat} />
            }
            <div className="text-center">
              {
                registrationType === 'internal' &&
                <div>
                  <p className="text-sm text-gray-444">
                    {translate('EVENT', 'guest_total')}: {guest_total}/{guest_seat}
                  </p>
                  <div className="flex justify-center items-center mb-4">
                    <p className="text-sm text-primary underline mr-1">
                      <Link to={`/dashboard/events/${id}/guest-list`}>
                        {translate('EVENT', 'view_guests')}
                      </Link>
                    </p>
                  </div>
                </div>
              }

              <SidebarStatus isEdit={isEdit}/>

              {
                registrationType === 'internal' &&
                <p className="text-sm text-gray-444">
                    {translate('EVENT', 'registration_end_date')}: <br/>
                    {
                      language.name === 'en' ? dayjs(registration_end_date).format('MMM/DD/YYYY') : dayjs(registration_end_date).locale('id').format('DD MMMM YYYY')
                    }
                </p>
              }
            </div>
          </div>
        </div>
      }

      <FormProfile />

      <hr className="my-8 lg:my-10"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">{translate('GENERAL', 'location')}</p>
      <Label>{translate('EVENT', 'location_type')}</Label>
      <Select
        className="text-sm"
        options={[
          {
            label: translate('GENERAL', 'online'),
            value: 'online'
          },
          {
            label: translate('GENERAL', 'offline'),
            value: 'offline'
          },
          {
            label: translate('GENERAL', 'online-offline'),
            value: 'both'
          }
        ]}
        value={locationType}
        onChange={(e) => setLocationType(e)}
      />

      <hr className="my-8 lg:my-10"/>

      {
        locationType.value === 'offline' && <FormLocation />
      }
      {
        locationType.value === 'online' && <FormLocationOnline />
      }
      {
        locationType.value === 'both' && <>
          <FormLocation />
          <hr className="my-8 lg:my-10"/>
          <FormLocationOnline />
        </>
      }

      <hr className="my-8 lg:my-10"/>

      <DevLogger data={form}/>

      <GalleryForm onChange={handleGalleryChange}/>

      {
        (form.gallery_saved && form.gallery_saved.length > 0) &&
        <div className="mt-8">
          {/* Saved Gallery Preview */}
          <Label>{translate('GENERAL', 'gallery')} (Database)</Label>
          <GalleryDropzonePreview
            items={form.gallery_saved?.map(d => d.url)}
            onRemove={handleDeleteGalleryItem}
          />
        </div>
      }

      <hr className="my-8 lg:my-10"/>

      <SectionTestimonial />

      <hr className="my-8 lg:my-10"/>

      <SectionComment />

      <hr className="my-8 lg:hidden"/>

      {
        notificationFormPopedUp &&
        <NotificationFormPopup onClose={(val) => setNotificationFormPopedUp(val)}/>
      }
    </div>
  )
}

export { Form }
